import type * as model from './models';
import axios from '../common/request';

/** web-account-controller 官网获取广告主基本信息 */
export async function getWebAccountInfoUsingPOST() {
  const result = await axios.request<model.IResultViewWebAccountInfo>({
    url: `/rest/i18n/web/account/info`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
  });

  return result.data;
}
